//src/useroom.js use to fetch and filter room in v-select
import { reactive, ref, onMounted, toRefs } from "vue";
import { db } from "@/firebaseConfig";
import { collection, getDocs, onSnapshot } from "firebase/firestore";

export const roomStore = reactive({
  roomItems: [],
  isLoading: false,
  error: null,
});
const fetchroom = async () => {
  roomStore.isLoading = true;
  roomStore.error = null;

  try {
    const roomCollectionRef = collection(db, "nurse");

    onSnapshot(
      roomCollectionRef,
      (querySnapshot) => {
        const fetchedRooms = [];
        querySnapshot.forEach((doc) => {
          const roomData = doc.data();
          // Ensure the objects pushed into roomItems have 'id' and 'rName'
          fetchedRooms.push({
            id: doc.id,
            rName: roomData.rName,
            available: roomData.available,
          });
        });
        roomStore.roomItems = fetchedRooms;
        roomStore.isLoading = false;
      },
      (error) => {
        console.error("Error fetching room data:", error);
        roomStore.error = error;
        roomStore.isLoading = false;
      }
    );
  } catch (err) {
    console.error("Failed to set up room data listener:", err);
    roomStore.error = err;
    roomStore.isLoading = false;
  }
};
export function useroom() {
  onMounted(() => {
    fetchroom();
  });

  return {
    ...toRefs(roomStore),
    fetchroom,
  };
}
